import { render, staticRenderFns } from "./TsPendingConfirmation.vue?vue&type=template&id=923094dc&"
import script from "./TsPendingConfirmation.vue?vue&type=script&lang=js&"
export * from "./TsPendingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports